import parseUrl from 'url-parse';

export const redirect = (url) => {
  window.location = url;
};

export const getReferrerUrl = () => document.referrer;

/** Is the URL including the domain which hosts climate FieldView globally?
* @param {string} url URL to check.
* @return {boolean} True if it is, false if not. */
export const isClimateFieldViewAppUrl = (url) =>
  (/https:\/\/(qa1\.|local\.)?climate\.com\/static\//g).test(url);


const PARSE_ERROR = 'localhost';
export const getHostnameFromUrl = (url) => {
  const hostname = parseUrl(url).hostname.toLowerCase();
  if (hostname === PARSE_ERROR) {
    return null;
  }
  // Omit optional www. from beginning to further normalize.
  return (hostname.indexOf('www.') === 0) ? hostname.substr(4) : hostname;
};

/** Transforms auth-pages URL into tcc-auth-plugin URL
* @param {string} href URL to modify
* @return {string} TCC Auth plugin url matching */
export function getTCCAuthPluginUrl(href) {
  const url = new URL(href);
  const hash = url.hash.replace('#', `#/auth`) || '#/auth';

  return `${url.origin}/static/fv2${hash}${url.search}`;
}